import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature, DeliveryType } from 'webapp/enums/enums';
import { NotificationFilterType, NotificationScheduleType } from 'webapp/enums/notifications';

import type { Reminder } from 'webapp/models-custom';
import NotificationBase from 'webapp/models-custom/notification/base';

export default class NotificationReminder extends NotificationBase {
	@service('model-manager/reminders')
	declare mmRemindersService: Service.ModelManager.Reminders;
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;

	type = NotificationFilterType.REPORT;
	scheduleType = NotificationScheduleType.REMINDER;
	targetObject: Reminder;
	typeColor = 'var(--databox-violet-500)';
	typeIcon: IconName = 'Reports';

	override billingFeature = BillingFeature.REPORTS_BASIC;

	constructor(model: Reminder) {
		super();
		this.targetObject = model;
	}

	get report() {
		return this.targetObject.report;
	}

	get title() {
		return this.report?.title || '';
	}

	get subtitleText() {
		return this.report?.slideCountText || '';
	}

	get isMine() {
		return true;
	}

	get schedule() {
		return this.targetObject.schedule;
	}

	get frequency() {
		const frequency = this.mmNotificationsService.getFrequencyFromSchedule(this.schedule.type);
		return frequency ? [frequency] : [];
	}

	override get frequencySortProp() {
		return this.schedule.deliveryTimeLevel;
	}

	get frequencyTooltipTextTop() {
		const schedule = this.schedule;
		return `${schedule.typeText} ${schedule.timeText}`;
	}

	get createdBy() {
		return this.currentUserService.model?.model || null;
	}

	get createdOn() {
		return null;
	}

	get deliveryTypes() {
		return [DeliveryType.EMAIL];
	}

	get emailRecipients() {
		const myId = this.currentUserService.numericId!;
		return [myId];
	}

	get allRecipients() {
		return this.mmUsersService.getMappedRecipients([]);
	}

	delete() {
		// is me-only
		const reminder = this.targetObject;
		void reminder.deleteAndCatch();
	}
}
